import { getFetchedDataPayload } from '@vista-digital/utilities';
import { getFetchedSiteById } from './get-fetched-site-by-id';
export const getSiteById = (id) => {
    return getFetchedDataPayload(getFetchedSiteById(id));
};
//# sourceMappingURL=get-site-by-id.js.map